import { render, staticRenderFns } from "./BTablePublicationFormdataAteNotStarted.vue?vue&type=template&id=4717df2b&"
import script from "./BTablePublicationFormdataAteNotStarted.vue?vue&type=script&lang=js&"
export * from "./BTablePublicationFormdataAteNotStarted.vue?vue&type=script&lang=js&"
import style0 from "./BTablePublicationFormdataAteNotStarted.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports